import { useState } from 'react';
import { Link } from 'react-router-dom';
import { rankings } from '@/mocks/novels';

type TabKey = 'weekly' | 'monthly' | 'completed';

const tabs: { key: TabKey; label: string }[] = [
  { key: 'weekly', label: '阅读周榜' },
  { key: 'monthly', label: '评分月榜' },
  { key: 'completed', label: '完本精选' },
];

export default function RankingSection() {
  const [activeTab, setActiveTab] = useState<TabKey>('weekly');
  const currentList = rankings[activeTab].slice(0, 8);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              排行榜
            </h2>
            <p className="text-sm text-foreground-500 mt-2">最受读者喜爱的作品</p>
          </div>
          <div className="flex items-center gap-1 bg-background-200/70 p-1 rounded-full self-start">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-5 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === tab.key
                    ? 'bg-primary-500 text-background-50 font-medium'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {currentList.map((novel, index) => (
            <Link
              key={novel.id}
              to={`/article/${novel.id}`}
              className="flex items-center gap-4 p-4 bg-background-50 rounded-lg border border-background-200/70 transition-all duration-300 hover:-translate-x-1 hover:border-primary-200 cursor-pointer group"
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-heading flex-shrink-0 ${
                  index < 3
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {index + 1}
              </div>
              <img
                src={novel.coverImage}
                alt={novel.title}
                className="w-12 h-16 object-cover rounded flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {novel.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{novel.author} · {novel.category}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-sm text-accent-600 font-medium flex items-center gap-1">
                  <i className="ri-star-fill text-xs"></i>
                  {novel.rating}
                </p>
                <p className="text-xs text-foreground-400 mt-0.5">{novel.status}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}